import React, { useEffect, useState } from 'react';
import { AddIcon } from '@assets/icons/addIcon';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Loading from '@components/Loading';
import DownloadIcon from '@assets/icons/downloadIcon';

const Button:React.FC<IProps> = (props) => {
  let style = {...props.style}
  
  let backgroundColor;
  if (style && style.backgroundColor) backgroundColor = style.backgroundColor
  if (style && style.backgroundColor) delete style.backgroundColor
  let hoverBackgroundColor;
  if (style && style.hoverBackgroundColor) hoverBackgroundColor = style.hoverBackgroundColor
  if (style && style.hoverBackgroundColor) delete style.hoverBackgroundColor

  const handleOnClick = (e: any) => {
    if (!props.disabled) props.onClick(e);
    else e.preventDefault();
  };

  return (
    <S.Root
      backgroundColor={props.disabled === true ? C.GENERIC_GRAY : backgroundColor} 
      hoverBackgroundColor={props.disabled === true ? C.GENERIC_GRAY : hoverBackgroundColor}
      style={style}
      onClick={handleOnClick}
    >
      {props.icon === "add" &&
        <AddIcon style={{...props.iconStyle, marginRight: 5}}/>
      }
      {
        (props.loading??false) ?
        <>
        <S.Text>&nbsp;</S.Text>
        <Loading 
          id={"loading-image"}
          containerStyle={{position:'absolute', marginTop:'auto', height:'40px'}}
        />
        </>
        :
        <S.Text style={props.labelStyle ? props.labelStyle : {}}>{props.label}</S.Text>
      }
      {props.icon === "download" &&
        <DownloadIcon style={{...props.iconStyle, marginLeft: 5}}/>
      }
    </S.Root>
  );
}

export default Button;